import * as React from 'react';
import classes from './SquareButton.module.scss';
import { numberAbbreviator } from '../../../helpers/numberAbbreviator';
import classNames from 'classnames';
import { SquareButtonIconsEnum } from '../../../constants/square-button-icons';
import { SquareButtonIcon } from '../../images/Icon/SquareButtonIcon';
import { MouseEventHandler } from 'react';

export type SquareButtonViewProps = {
  action: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
  active?: boolean;
  badge?: number;
  disabled?: boolean;
  elementType?: 'a' | 'button';
  icon: SquareButtonIconsEnum;
  id?: string;
  type: 'white' | 'transparent' | 'darkTransparent';
  className?: string;
};

export const SquareButtonView = (props: SquareButtonViewProps): JSX.Element => {
  const buttonClasses = classNames(
    classes.SquareButton,
    {
      [classes.SquareButtonDefault]: props.type === 'transparent' && !props.active,
      [classes[`SquareButtonDefault${props.icon}`]]: props.type === 'transparent' && !props.active,
      [classes.SquareButtonDefaultWhite]: props.type === 'white' && !props.active,
      [classes[`SquareButtonDefaultWhite${props.icon}`]]: props.type === 'white' && !props.active,
      [classes.SquareButtonDarkTransparent]: props.type === 'darkTransparent' && !props.active,
      [classes[`SquareButtonDarkTransparent${props.icon}`]]: props.type === 'darkTransparent' && !props.active,

      [classes.SquareButtonActive]: props.type === 'transparent' && props.active,
      [classes[`SquareButtonActive${props.icon}`]]: props.type === 'transparent' && props.active,
      [classes.SquareButtonActiveWhite]: props.type === 'white' && props.active,
      [classes[`SquareButtonActiveWhite${props.icon}`]]: props.type === 'white' && props.active,
      [classes.SquareButtonDarkTransparentActive]: props.type === 'darkTransparent' && props.active,
      [classes[`SquareButtonDarkTransparentActive${props.icon}`]]: props.type === 'darkTransparent' && props.active,

      [classes.Disabled]: props.disabled
    },
    props.className
  );
  const ButtonTag = `${props.elementType === 'button' ? 'button' : 'a'}` as keyof Pick<
    JSX.IntrinsicElements,
    'a' | 'button'
  >;
  const id = props.id ? { id: props.id } : null;
  const badgeClass = classNames(classes.BadgeClass);
  const badge = props.badge ? <span className={badgeClass}>{numberAbbreviator(props.badge)}</span> : null;
  return (
    <ButtonTag {...id} onClick={props.action} className={buttonClasses}>
      <SquareButtonIcon name={props.icon} />
      {badge}
    </ButtonTag>
  );
};
